module.exports = __webpack_public_path__ + "img/polygon.447d82a8.png";